// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { termsAndConditionsService } from './service';
import * as termsAndConditionsActions from './actions';
import * as types from './actionTypes';

function* termsAndConditionsSaga() {
  const res = yield call(termsAndConditionsService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title } = result;
    let { paragraphs } = result;
    paragraphs = paragraphs.map((el) => {
      return {
        title: el.title,
        text: el.text,
      };
    });

    yield put(termsAndConditionsActions.requestPageDataSuccess({
      title,
      paragraphs,
    }));
  }
}

const termsAndConditionsSagas = [
  takeEvery(types.TC_REQUEST_PAGE_DATA, termsAndConditionsSaga),
];

export default termsAndConditionsSagas;
